import { InferQueryModel } from '@trashlab/api/src/types/drizzle-type-helpers';
import { HydratedOrderPhoto } from '@trashlab/api/src/domains/orders/types/order-photo';
import {
  trpcConsumerGetCart,
  trpcConsumerGetWebsiteCart,
  trpcConsumerListPricing,
} from '@trashlab/api/src/generated/hooks';

export const ShopSteps = [
  'site-address',
  'select-package',
  'select-upsell-items',
  'select-dates',
  'submit-notes-and-others',
  'submit-payment-step',
  'confirmation',
] as const;

export const ShopStep = {
  SiteAddress: ShopSteps[0],
  SelectPackage: ShopSteps[1],
  SelectUpsellItems: ShopSteps[2],
  SelectDates: ShopSteps[3],
  SubmitNotesAndOthers: ShopSteps[4],
  SubmitPaymentStep: ShopSteps[5],
  Confirmation: ShopSteps[6],
} as const;

export type ShopStepsType = (typeof ShopSteps)[number];

export type ConsumerCartData = typeof trpcConsumerGetCart.output;

export type ListPricing = typeof trpcConsumerListPricing.output;

export type UpsellItem = InferQueryModel<
  'upsell_item',
  {
    with: {
      price: {
        columns: {
          id: true;
          chargeFee: true;
          priceName: true;
          priceType: true;
          taxable: true;
        };
      };
    };
  }
> & {
  photo?: HydratedOrderPhoto | null;
};

export const TLSiteShopSteps = [
  'tl-site-information',
  'tl-site-select-upsell-items',
  'tl-site-delivery-and-pickup',
  'tl-site-payment',
  'tl-site-confirmation',
] as const;

export const TLSiteShopStep = {
  Information: TLSiteShopSteps[0],
  SelectUpsellItems: TLSiteShopSteps[1],
  DeliveryAndPickup: TLSiteShopSteps[2],
  Payment: TLSiteShopSteps[3],
  Confirmation: TLSiteShopSteps[4],
} as const;

export type TLSiteShopStepsType = (typeof TLSiteShopSteps)[number];

export type TLSiteCartData = typeof trpcConsumerGetWebsiteCart.output;